/** Maximum accepted length of a returnTo path. */
export const RETURN_TO_MAX_LENGTH = 512;
/**
 * Validate a post-redirect `returnTo` value as a same-origin relative path
 * (ENG-277). Returns the value unchanged when safe, otherwise `null`.
 * Never throws.
 *
 * Accepted: strings of 1–512 chars starting with a single `/` whose second
 * char is not `/` or `\`, containing no backslash, no control characters
 * (code < 32 or 127) and no `://`.
 *
 * @example
 * safeReturnTo("/teams/abc?tab=settings") // → "/teams/abc?tab=settings"
 * safeReturnTo("//evil.com")              // → null
 */
export function safeReturnTo(value) {
    if (typeof value !== "string")
        return null;
    if (value.length < 1 || value.length > RETURN_TO_MAX_LENGTH)
        return null;
    if (!value.startsWith("/"))
        return null;
    const second = value.charAt(1);
    if (second === "/" || second === "\\")
        return null;
    if (value.includes("\\"))
        return null;
    if (value.includes("://"))
        return null;
    for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i);
        if (code < 32 || code === 127)
            return null;
    }
    return value;
}
//# sourceMappingURL=return-to.js.map